import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';

export const ActivateForm = styled.div``;

export const FormWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px 8px;

  *:nth-child(n + 3) {
    grid-column: span 2;
  }
`;

export const DisclaimerText = styled.p`
  ${fontBody(14)};
  text-align: center;
  margin-top: 16px;

  & > a {
    color: var(--foreground);
    text-decoration: underline;
  }
`;

export const DescriptionText = styled.p`
  ${fontBody(16)};
  text-align: center;
  margin-bottom: 16px;
`;

export const Bold = styled.span`
  font-weight: 800;
`;
